import { render, staticRenderFns } from "./base-row.vue?vue&type=template&id=3b8b189a"
import script from "./base-row.vue?vue&type=script&lang=js"
export * from "./base-row.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports